import { SearchOutlined } from '@ant-design/icons';
import {
    Button,
    Form,
    Input,
    Row,
    Col,
    Select,
    Table,
    Tooltip,
    Tag,
} from 'antd';

import IconNotFound from '../../../assets/Images/icons/empty';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import UserManagementService from '../../../services/UserManagement.service';
import DataInventoryService from '../../../services/DataInventory.service';
import IconBack from '../../../assets/Images/icons/icon-back';
import UserService from '../../../services/UserService';
import { ROUTER } from '../../../constants/router';
import RevokeInvite from '../../../components/Shared/modal/confirm';
import ResendInvite from '../../../components/Shared/modal/confirm';
import ResetPassword from '../../../components/Shared/modal/confirm';
import IconResendEmail from '../../../assets/Images/icons/icon-resend-email';
import useNotify from '../../../context/Notification/useNotify';
import usePermission from '../../../hooks/usePermission';

const { Option } = Select;

const statusList = [
    {
        id: 'WAITING',
        nameEn: 'Waiting for active',
        nameTh: 'รอการเปิดใช้งาน',
    },
    {
        id: 'ACTIVE',
        nameEn: 'Active',
        nameTh: 'เปิดใช้งาน',
    },
    {
        id: 'INACTIVE',
        nameEn: 'Inactive',
        nameTh: 'ปิดใช้งาน',
    },
];

const UserListPage = () => {
    const { t, i18n } = useTranslation();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const notify = useNotify();
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        sortBy: 'name',
        sortDirection: 'ASC',
        total: 0,
    });
    const [searchValue, setSearchValue] = useState({
        name: null,
        staffId: null,
        departmentId: null,
        roleId: null,
    });
    const [loading, setLoading] = useState(0);

    const [data, setData] = useState([]);
    const [roleUser, setRoleUser] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [openResendInvite, setOpenResendInvite] = useState(false);
    const [openRevokeInvite, setOpenRevokeInvite] = useState(false);
    const [openResetPassword, setOpenResetPassword] = useState(false);
    const [item, setItem] = useState();

    useEffect(() => {
        if (loading === 0) {
            searchUser(searchValue, currentPage);
            getRoleUser();
            getDepartmentList();
            setLoading(1);
        }
    }, [currentPage, loading, searchValue]);

    const searchUser = (searchValue, pageValue) => {
        // setData();
        const payload = {
            keyword: searchValue.keyword || null,
            staffId: searchValue.staffId || null,
            departmentId: searchValue.departmentId || null,
            roleId: searchValue.roleId || null,
            status: searchValue.status || null,
            p: pageValue.page || 1,
            ps: pageValue.pageSize || 10,
            s: pageValue.sortBy || 'name',
            sd: pageValue.sortDirection || 'ASC',
        };
        UserManagementService.searchUser(payload).then((res) => {
            setData(res?.data?.resultData?.result || []);
            setCurrentPage({
                page: res?.data?.resultData.page,
                pageSize: res?.data?.resultData.pageSize,
                total: res?.data?.resultData.total,
            });
        });
    };
    const getRoleUser = () => {
        UserManagementService.getRoleUser().then((res) => {
            setRoleUser(res?.data?.resultData || []);
        });
    };
    const getDepartmentList = () => {
        DataInventoryService.getDepartmentList().then((res) => {
            setDepartmentList(res?.data?.resultData || []);
        });
    };

    const onSearch = async () => {
        const { getFieldsValue } = form;
        const searchValues = {
            keyword: getFieldsValue().keyword || null,
            staffId: getFieldsValue().staffId || null,
            departmentId: getFieldsValue().departmentId || null,
            roleId: getFieldsValue().roleId || null,
            status: getFieldsValue().status || null,
        };
        const search = {
            page: 1,
            pageSize: 10,
            sortBy: 'name',
            sortDirection: 'ASC',
            total: 0,
        };
        setSearchValue(searchValues);
        searchUser(searchValues, search);
    };

    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    const { isUser } = usePermission();

    const columns = [
        {
            title: 'No.',
            dataIndex: 'no',
            width: 30,
            render: (_, __, index) => {
                const numPage = currentPage.page - 1;
                const number = index + 1;
                const sum = numPage * 10;
                return <div className="font-semibold">{number + sum}</div>;
            },
        },

        {
            title: t('Name'),
            dataIndex: 'name',
            key: 'name',
            sorter: () => null,
            render: (value, record) => {
                return (
                    <div className="space-y-1">
                        <div className="font-semibold text-sm">{value}</div>
                        <div className="text-xs">{record?.email}</div>
                    </div>
                );
            },
        },
        {
            title: t('Staff ID'),
            dataIndex: 'staffId',
            key: 'staffId',
            sorter: () => null,
            render: (value) => {
                return <div className="font-semibold text-sm">{value}</div>;
            },
        },
        {
            title: t('Department'),
            dataIndex: i18n.language === 'en' ? 'departmentEn' : 'departmentTh',
            key: 'department',
            sorter: () => null,
            render: (value) => {
                return <div className="font-semibold text-sm">{value}</div>;
            },
        },
        {
            title: t('Role'),
            dataIndex: 'role',
            key: 'role',
            sorter: () => null,
            render: (value) => {
                return <div className="font-semibold text-sm">{value}</div>;
            },
        },
        {
            title: t('Status'),
            dataIndex: 'userStatusName',
            key: 'userStatusName',
            align: 'center',
            render: (userStatusName, record) => (
                <>
                    {userStatusName === 'WAITING' && (
                        <Tag className="rounded-xl -my-1 text-center bg-[#F9C153] border-[#F9C153] text-white">
                            {t('Waiting for active')}
                        </Tag>
                    )}
                    {userStatusName === 'ACTIVE' && (
                        <Tag className="rounded-xl -my-1 text-center bg-[#4ACE8F] border-[#4ACE8F] text-white">
                            {t('Active')}
                        </Tag>
                    )}
                    {userStatusName === 'INACTIVE' && (
                        <Tag className="rounded-xl -my-1 text-center bg-[#F0536F] border-[#F0536F] text-white">
                            {t('InActive')}
                        </Tag>
                    )}
                </>
            ),
        },
        {
            title: t('Action'),
            key: 'action',
            align: 'left',
            width: 200,
            hidden: isUser,
            render: (text, record) => (
                <span className="space-x-2">
                    <Tooltip
                        placement="bottom"
                        title={t('View')}
                        className="cursor-pointer hover:opacity-80"
                    >
                        <svg
                            onClick={() =>
                                navigate(
                                    `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list/view-user/${record.id}`
                                )
                            }
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="32"
                                height="32"
                                rx="6"
                                fill="#F3F6F9"
                            />
                            <path
                                d="M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M23.47 15.83C22.882 14.3088 21.861 12.9933 20.5334 12.046C19.2058 11.0988 17.6298 10.5613 16 10.5C14.3703 10.5613 12.7942 11.0988 11.4666 12.046C10.139 12.9933 9.11811 14.3088 8.53003 15.83C8.49032 15.9399 8.49032 16.0601 8.53003 16.17C9.11811 17.6912 10.139 19.0067 11.4666 19.954C12.7942 20.9012 14.3703 21.4387 16 21.5C17.6298 21.4387 19.2058 20.9012 20.5334 19.954C21.861 19.0067 22.882 17.6912 23.47 16.17C23.5097 16.0601 23.5097 15.9399 23.47 15.83ZM16 19.25C15.3572 19.25 14.7289 19.0594 14.1944 18.7023C13.66 18.3452 13.2434 17.8376 12.9974 17.2437C12.7514 16.6499 12.6871 15.9964 12.8125 15.366C12.9379 14.7355 13.2474 14.1564 13.7019 13.7019C14.1565 13.2474 14.7355 12.9378 15.366 12.8124C15.9964 12.687 16.6499 12.7514 17.2438 12.9974C17.8376 13.2434 18.3452 13.6599 18.7023 14.1944C19.0594 14.7289 19.25 15.3572 19.25 16C19.2487 16.8615 18.9059 17.6874 18.2967 18.2966C17.6875 18.9058 16.8616 19.2487 16 19.25Z"
                                fill="#7B67FB"
                            />
                        </svg>
                    </Tooltip>

                    <Tooltip
                        placement="bottom"
                        title={t('Edit')}
                        className="cursor-pointer hover:opacity-80"
                    >
                        <svg
                            hidden={!admin}
                            onClick={() =>
                                navigate(
                                    `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list/edit-user/${record.id}`
                                )
                            }
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="32"
                                height="32"
                                rx="6"
                                fill="#F3F6F9"
                            />
                            <path
                                d="M20.6586 9.34131L22.6586 11.3413L21.1339 12.8666L19.1339 10.8666L20.6586 9.34131ZM13.3333 18.6666H15.3333L20.1913 13.8086L18.1913 11.8086L13.3333 16.6666V18.6666Z"
                                fill="#7B67FB"
                            />
                            <path
                                d="M20.6667 20.6667H13.4387C13.4213 20.6667 13.4033 20.6733 13.386 20.6733C13.364 20.6733 13.342 20.6673 13.3193 20.6667H11.3333V11.3333H15.898L17.2313 10H11.3333C10.598 10 10 10.5973 10 11.3333V20.6667C10 21.4027 10.598 22 11.3333 22H20.6667C21.0203 22 21.3594 21.8595 21.6095 21.6095C21.8595 21.3594 22 21.0203 22 20.6667V14.888L20.6667 16.2213V20.6667Z"
                                fill="#7B67FB"
                            />
                        </svg>
                    </Tooltip>

                    <Tooltip
                        placement="bottom"
                        title={
                            record?.userStatusName === 'ACTIVE'
                                ? t('Reset Password')
                                : t('Resend Invite')
                        }
                        className="cursor-pointer hover:opacity-80"
                    >
                        <svg
                            hidden={
                                !admin || record?.userStatusName === 'INACTIVE'
                            }
                            onClick={() => {
                                if (record?.userStatusName === 'ACTIVE') {
                                    setItem(record);
                                    setOpenResetPassword(true);
                                } else {
                                    setItem(record);
                                    setOpenResendInvite(true);
                                }
                            }}
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="32"
                                height="32"
                                rx="6"
                                fill="#F3F6F9"
                            />
                            <path
                                d="M22.5 11H9.5C9.22344 11 9 11.2234 9 11.5V21.5C9 21.7766 9.22344 22 9.5 22H22.5C22.7766 22 23 21.7766 23 21.5V11.5C23 11.2234 22.7766 11 22.5 11ZM21.875 12.7313V20.875H10.125V12.7313L9.69375 12.3953L10.3078 11.6063L10.9766 12.1266H21.025L21.6938 11.6063L22.3078 12.3953L21.875 12.7313ZM21.025 12.125L16 16.0313L10.975 12.125L10.3063 11.6047L9.69219 12.3938L10.1234 12.7297L15.4609 16.8797C15.6144 16.9989 15.8033 17.0637 15.9977 17.0637C16.192 17.0637 16.3809 16.9989 16.5344 16.8797L21.875 12.7313L22.3062 12.3953L21.6922 11.6063L21.025 12.125Z"
                                fill="#7B67FB"
                            />
                        </svg>
                    </Tooltip>

                    <Tooltip
                        placement="bottom"
                        title={t('Revoke Invite')}
                        className="cursor-pointer hover:opacity-80"
                    >
                        <svg
                            hidden={
                                !admin || record?.userStatusName !== 'WAITING'
                            }
                            onClick={() => {
                                setItem(record);
                                setOpenRevokeInvite(true);
                            }}
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="32"
                                height="32"
                                rx="6"
                                fill="#F3F6F9"
                            />
                            <path
                                d="M16 9C16.549 8.99992 17.0781 9.20504 17.4835 9.57509C17.8889 9.94513 18.1413 10.4534 18.1912 11H21.6C21.7521 11 21.8984 11.0578 22.0095 11.1616C22.1206 11.2654 22.1881 11.4074 22.1985 11.5591C22.2088 11.7108 22.1612 11.8607 22.0653 11.9786C21.9694 12.0966 21.8322 12.1737 21.6816 12.1944L21.6 12.2H21.1336L20.12 20.984C20.0749 21.3739 19.888 21.7336 19.5949 21.9947C19.3018 22.2558 18.923 22.4001 18.5304 22.4H13.4696C13.0771 22.4001 12.6983 22.2558 12.4052 21.9947C12.1121 21.7336 11.9252 21.3739 11.88 20.984L10.8656 12.2H10.4C10.2551 12.2 10.115 12.1475 10.0057 12.0522C9.89643 11.9569 9.82537 11.8252 9.80565 11.6816L9.80005 11.6C9.80005 11.455 9.85256 11.3149 9.94786 11.2057C10.0432 11.0964 10.1748 11.0253 10.3184 11.0056L10.4 11H13.8088C13.8587 10.4534 14.1112 9.94513 14.5166 9.57509C14.922 9.20504 15.4511 8.99992 16 9ZM14.8 14C14.604 14 14.44 14.124 14.4064 14.2872L14.4 14.3504V19.2504L14.4064 19.3128C14.44 19.476 14.604 19.6 14.8 19.6C14.996 19.6 15.16 19.476 15.1936 19.3128L15.2 19.2496V14.3512L15.1936 14.2872C15.16 14.1248 14.996 14 14.8 14ZM17.2 14C17.004 14 16.84 14.124 16.8064 14.2872L16.8 14.3504V19.2504L16.8064 19.3128C16.84 19.476 17.004 19.6 17.2 19.6C17.396 19.6 17.56 19.476 17.5936 19.3128L17.6 19.2496V14.3512L17.5936 14.2872C17.56 14.1248 17.396 14 17.2 14ZM16 10.2C15.516 10.2 15.112 10.544 15.02 11H16.98C16.8872 10.544 16.484 10.2 16 10.2Z"
                                fill="#7B67FB"
                            />
                        </svg>
                    </Tooltip>
                </span>
            ),
        },
    ].filter((item) => !item.hidden);

    const paginationProps = {
        current: parseInt(currentPage.page),
        // pageSize: 10,
        total: parseInt(currentPage.total),
        // showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
    };

    const onPageChange = async (pagination, filters, sorter) => {
        const pageValues = {
            page: pagination.current,
            pageSize: pagination.pageSize,
            sortBy: sorter && sorter.order ? sorter.columnKey : 'name',
            sortDirection:
                sorter && sorter.order
                    ? sorter.order.substring(0, 3).toUpperCase() === 'ASC'
                        ? 'asc'
                        : 'desc'
                    : 'asc',
            //   total: pageValue.total,
            total: currentPage.total,
        };
        setCurrentPage(pageValues);
        searchUser(searchValue, pageValues);
        // getAllLandlordAdmin(searchValue, pageValues);
    };

    const handelRevoked = async () => {
        try {
            const { data } = await UserManagementService.RevokeInvite(item?.id);
            if (data?.resultCode === 1) {
                setOpenRevokeInvite(false);
                await notify({
                    title: t('common.Success'),
                    description: t('Successfully revoke invite'),
                });
                setItem();
                searchUser(
                    {
                        keyword: null,
                        staffId: null,
                        departmentId: null,
                        roleId: null,
                        status: null,
                    },
                    {
                        page: 1,
                        pageSize: 10,
                        sortBy: 'name',
                        sortDirection: 'asc',
                    }
                );
            } else {
                setOpenRevokeInvite(false);
                await notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to revoke invite'),
                    timeOut: 120000,
                    closeable: true,
                });
                setItem();
                searchUser(
                    {
                        keyword: null,
                        staffId: null,
                        departmentId: null,
                        roleId: null,
                        status: null,
                    },
                    {
                        page: 1,
                        pageSize: 10,
                        sortBy: 'name',
                        sortDirection: 'asc',
                    }
                );
            }
        } catch (error) {
            setOpenRevokeInvite(false);
            await notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to revoke invite'),
                timeOut: 120000,
                closeable: true,
            });
            setItem();
            searchUser(
                {
                    keyword: null,
                    staffId: null,
                    departmentId: null,
                    roleId: null,
                    status: null,
                },
                {
                    page: 1,
                    pageSize: 10,
                    sortBy: 'name',
                    sortDirection: 'asc',
                }
            );
            console.log(error);
        }
    };

    return (
        <div className="bg-gray-body ">
            <div className="title flex">
                <button
                    type="button"
                    className="cursor-pointer mr-3"
                    onClick={() =>
                        navigate(ROUTER.CONFIGURATION.USER_MANAGEMENT)
                    }
                >
                    <IconBack />
                </button>
                {t('User List')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.Configuration')} / {t('User Management')} /{' '}
                </span>
                <span> {t('User List')}</span>
            </div>
            <div className="w-full m-auto">
                <div
                    className="content bg-white px-5 pt-8 pb-2 mt-6"
                    style={{ borderRadius: '6px' }}
                >
                    <div className="search pb-3">
                        <Row className="mb-1 -mt-2">
                            <label
                                style={{ fontSize: '20px', fontWeight: 500 }}
                            >
                                {t('Search Filter')}
                            </label>
                        </Row>

                        <Form
                            scrollToFirstError={{
                                behavior: 'smooth',
                                block: 'center',
                            }}
                            form={form}
                            layout="inline"
                            className="flex items-center my-4"
                        >
                            <Form.Item
                                className="w-[22%]"
                                name="keyword"
                                colon={false}
                            >
                                <Input
                                    size="large"
                                    className="rounded-md w-full"
                                    placeholder={t('userManagement.Keyword')}
                                    allowClear
                                    prefix={<SearchOutlined />}
                                />
                            </Form.Item>
                            <Form.Item
                                className="w-[20%]"
                                name="departmentId"
                                colon={false}
                            >
                                <Select
                                    style={{
                                        width: '100%',
                                    }}
                                    className="w-full"
                                    size="large"
                                    placeholder={t('Department')}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.children ?? '')
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                >
                                    {departmentList.map((list) => (
                                        <Option
                                            key={list.departmentId}
                                            value={list.departmentId}
                                        >
                                            {list.nameEn}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                className="w-[20%]"
                                colon={false}
                                name="roleId"
                            >
                                <Select
                                    style={{
                                        width: '100%',
                                    }}
                                    className="w-full"
                                    size="large"
                                    placeholder={t('Select Role')}
                                    optionFilterProp="children"
                                >
                                    {roleUser.map((role) => (
                                        <Option key={role.id} value={role.id}>
                                            {role.role}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                className="w-[20%]"
                                colon={false}
                                name="status"
                            >
                                <Select
                                    style={{
                                        width: '100%',
                                    }}
                                    className="w-full"
                                    size="large"
                                    placeholder={t('userManagement.Status')}
                                    optionFilterProp="children"
                                >
                                    {statusList.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {i18n.language === 'en'
                                                ? item.nameEn
                                                : item.nameTh}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <div className="w-[11%] space-x-2 flex">
                                <Button
                                    size="large"
                                    className="min-w-[120px]"
                                    htmlType="submit"
                                    type="primary"
                                    onClick={(value) => onSearch(value)}
                                    icon={<SearchOutlined />}
                                >
                                    {t('Search')}
                                </Button>
                                <Button
                                    size="large"
                                    className="py-0 px-3 hover:opacity-80"
                                    style={{
                                        borderColor: '#7B67FB',
                                    }}
                                    type="primary"
                                    ghost
                                    onClick={() => {
                                        form.resetFields();
                                        const SearchValue = {
                                            keyword: null,
                                            staffId: null,
                                            departmentId: null,
                                            roleId: null,
                                            status: null,
                                        };
                                        setSearchValue({
                                            keyword: null,
                                            staffId: null,
                                            departmentId: null,
                                            roleId: null,
                                            status: null,
                                        });
                                        setCurrentPage({
                                            page: 0,
                                            pageSize: 10,
                                            sortBy: 'name',
                                            sortDirection: 'asc',
                                        });
                                        searchUser(SearchValue, currentPage);
                                    }}
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M15 5.707L14.293 5L12 7.293L9.707 5L9 5.707L11.293 8L9 10.2925L9.7075 11L12 8.707L14.2935 11L15 10.2935L12.707 8L15 5.707Z"
                                            fill="#7B67FB"
                                        />
                                        <path
                                            d="M2 2C1.73478 2 1.48043 2.10536 1.29289 2.29289C1.10536 2.48043 1 2.73478 1 3V4.585C0.999962 4.7164 1.02582 4.84651 1.07609 4.96791C1.12637 5.0893 1.20008 5.1996 1.293 5.2925L5 9V13C5 13.2652 5.10536 13.5196 5.29289 13.7071C5.48043 13.8946 5.73478 14 6 14H8C8.26522 14 8.51957 13.8946 8.70711 13.7071C8.89464 13.5196 9 13.2652 9 13V12H8V13H6V8.585L5.707 8.2925L2 4.5855V3H12V4H13V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2H2Z"
                                            fill="#7B67FB"
                                        />
                                    </svg>
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>

                <div
                    className="content bg-white p-8 mt-6"
                    style={{ borderRadius: '6px' }}
                >
                    <div className="content pb-3">
                        <Row>
                            <Col span={21}>
                                <Row>
                                    <div className="title ">
                                        {t('User List')}
                                    </div>
                                </Row>
                                <Row>
                                    <div className="sub-title">
                                        <span className="text-sm text-gray-400">
                                            {t('landing.UserListDes')}
                                        </span>
                                    </div>
                                </Row>
                                <Row className="my-4">
                                    <div className="sub-title">
                                        <span className="text-sm text-gray-500 font-semibold">
                                            {t('TotalItems', {
                                                length: currentPage.total,
                                            })}
                                        </span>
                                    </div>
                                </Row>
                            </Col>
                            <Col span={3}>
                                <Row
                                    style={{
                                        position: 'absolute',
                                        right: 0,
                                    }}
                                >
                                    {admin && (
                                        <div className="flex gap-2">
                                            <Button
                                                size="large"
                                                htmlType="submit"
                                                type="default"
                                                className="w-full text-[#7B67FB] border-[#7B67FB]"
                                                onClick={() =>
                                                    navigate(
                                                        `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list/import-user`
                                                    )
                                                }
                                            >
                                                {t('Import User')}
                                            </Button>
                                            <Button
                                                size="large"
                                                htmlType="submit"
                                                type="primary"
                                                className="w-full mr-2"
                                                onClick={() =>
                                                    navigate(
                                                        `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list/add-user`
                                                    )
                                                }
                                            >
                                                {t('Add User')}
                                            </Button>
                                        </div>
                                    )}
                                </Row>
                            </Col>
                        </Row>

                        <Table
                            locale={{ emptyText: <IconNotFound /> }}
                            className="inbox_table"
                            rowKey={(record, i) => record.id + i}
                            //loading={loading}
                            columns={columns}
                            dataSource={data}
                            pagination={paginationProps}
                            onChange={onPageChange}
                        />
                    </div>
                </div>
                {/* </div> */}
            </div>
            <RevokeInvite
                title={t('userManagement.ConfirmRevokeInvite')}
                icon={<IconResendEmail />}
                text={t('userManagement.InvitationLinksInactive')}
                open={openRevokeInvite}
                handelOk={handelRevoked}
                handelClose={() => setOpenRevokeInvite(false)}
            />
            <ResendInvite
                title={t('userManagement.ConfirmResendInvite')}
                icon={<IconResendEmail />}
                text={t('userManagement.EmailWillResendInvite')}
                open={openResendInvite}
                handelOk={async () => {
                    try {
                        const { data } =
                            await UserManagementService.ResendEmail({
                                email: item?.email,
                            });
                        if (data?.resultCode === 1) {
                            setOpenResendInvite(false);
                            await notify({
                                title: t('common.Success'),
                                description: t('Successfully resend invited'),
                            });
                            setItem();
                        } else {
                            setOpenResendInvite(false);
                            await notify({
                                type: 'error',
                                title: t('common.Fail'),
                                description: t('Failed to resend invited'),
                                timeOut: 120000,
                                closeable: true,
                            });
                            setItem();
                        }
                    } catch (error) {
                        setOpenResendInvite(false);
                        await notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to resend invited'),
                            timeOut: 120000,
                            closeable: true,
                        });
                        setItem();
                        console.log(error);
                    }
                }}
                handelClose={() => setOpenResendInvite(false)}
            />
            <ResetPassword
                title={t('userManagement.ConfirmResetPassword')}
                icon={<IconResendEmail />}
                text={t('userManagement.EmailWillSentResetPassword')}
                open={openResetPassword}
                handelOk={async () => {
                    try {
                        const { data } =
                            await UserManagementService.ResendEmail({
                                email: item?.email,
                            });
                        if (data?.resultCode === 1) {
                            setOpenResetPassword(false);
                            await notify({
                                title: t('common.Success'),
                                description: t('Successfully reset password'),
                            });
                            setItem();
                        } else {
                            setOpenResetPassword(false);
                            await notify({
                                type: 'error',
                                title: t('common.Fail'),
                                description: t('Failed to reset password'),
                                timeOut: 120000,
                                closeable: true,
                            });
                            setItem();
                        }
                    } catch (error) {
                        setOpenResetPassword(false);
                        await notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to reset password'),
                            timeOut: 120000,
                            closeable: true,
                        });
                        setItem();
                        console.log(error);
                    }
                }}
                handelClose={() => setOpenResetPassword(false)}
            />
        </div>
    );
};

export default UserListPage;
